/* mx-limite — limite de unidades por carta (MoxLand) */
(function () {
  if (window.__mxLimiteInit) return;
  window.__mxLimiteInit = true;

  var ARQ = document.documentElement.getAttribute('data-mx-limites');
  if (!ARQ) return;
  var regras = null, checando = false;

  function carregar() {
    if (regras) return Promise.resolve(regras);
    return fetch(ARQ).then(function (r) { return r.json(); })
      .then(function (d) {
        regras = { limite: d.limite || 4, livres: {} };
        (d.livres || []).forEach(function (id) {
          regras.livres[id] = 1;
        });
        return regras;
      }).catch(function () {
        regras = { limite: 4, livres: {} };
        return regras;
      });
  }

  function aviso(texto) {
    var v = document.querySelector('[data-mx-limite-aviso]');
    if (!v) {
      v = document.createElement('div');
      v.setAttribute('data-mx-limite-aviso', '');
      v.style.cssText = 'position:fixed;left:50%;bottom:24px;' +
        'transform:translateX(-50%);z-index:10050;max-width:92vw;' +
        'background:#111;color:#fff;padding:13px 18px;' +
        'border-radius:10px;font-size:14px;line-height:1.45;' +
        'box-shadow:0 8px 30px rgba(0,0,0,.3);text-align:center';
      document.body.appendChild(v);
    }
    v.innerHTML = texto;
    v.style.display = 'block';
    clearTimeout(v.__t);
    v.__t = setTimeout(function () { v.style.display = 'none'; },
      7000);
  }

  function conferir() {
    if (checando) return;
    checando = true;
    carregar().then(function (r) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (x) { return x.json(); })
        .then(function (cart) {
          var excesso = [];
          (cart.items || []).forEach(function (it) {
            if (r.livres[it.variant_id]) return;
            if (it.quantity > r.limite) {
              excesso.push({ id: it.variant_id,
                             nome: it.product_title,
                             qtd: it.quantity });
            }
          });
          if (!excesso.length) { checando = false; return; }
          var updates = {};
          excesso.forEach(function (x) {
            updates[x.id] = r.limite;
          });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () {
            var nomes = excesso.map(function (x) {
              return x.nome;
            }).join(', ');
            aviso('Máximo de <strong>' + r.limite + ' unidades' +
              '</strong> por carta.<br>Ajustamos: ' + nomes +
              '.<br>Precisa de mais? ' +
              '<a href="https://wa.me/551125033667" ' +
              'target="_blank" rel="noopener" ' +
              'style="color:#7CFFB2;text-decoration:underline">' +
              'Fale conosco</a>');
            checando = false;
            document.dispatchEvent(
              new CustomEvent('mx:carrinho-ajustado'));
            if (/\/cart/.test(window.location.pathname)) {
              setTimeout(function () {
                window.location.reload();
              }, 2600);
            }
          });
        });
    }).catch(function () { checando = false; });
  }

  /* confere depois de qualquer mexida no carrinho */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var alvo = (typeof url === 'string' ? url :
      (url && url.url) || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(alvo)) {
      p.then(function () { setTimeout(conferir, 350); })
        .catch(function () { /* ignora */ });
    }
    return p;
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) {
      setTimeout(conferir, 900);
    }
  }, true);
  if (/\/cart/.test(window.location.pathname)) {
    setTimeout(conferir, 700);
  }
})();
